import React from 'react';
import ReactTooltip from 'react-tooltip';

const TextTooltip = ({
  text = '',
  maxLength,

  place = 'top',
  type = 'dark',
  effect = 'solid',
}) => {
  return (
    <>
      <ReactTooltip place={place} type={type} effect={effect} />
      <span
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: '100%',
          display: 'block',
        }}
        data-tip={text}
      >
        {maxLength && text.length > maxLength
          ? `${text.substring(0, maxLength)}...`
          : `${text}`}
      </span>
    </>
  );
};

export default TextTooltip;
